import { Reducer } from "react";
import { changePageTitle, CHANGE_PAGE_TITLE, IPageTitle } from "./actions";

type State = IPageTitle | undefined;
type Action =
  | ReturnType<typeof changePageTitle>
  | { type: "OTHER_ACTION"; payload?: any };

const INITIAL_CONTEXT: IPageTitle = {
  title: "",
};

export const pageTitleReducer: Reducer<State, Action> = (
  previousState = INITIAL_CONTEXT,
  action
) => {
  if (action.type === CHANGE_PAGE_TITLE) {
    return action.payload;
  }
  return previousState;
};
